declare namespace $ {

	export class $mol_icon_refresh extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=refresh.view.tree.d.ts.map